import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
const PrivateRoutes = () => {
  let is_auth = useSelector((state) => state.auth.isAuthenticated);
  return is_auth ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoutes;
